<div class="tab-pane active container-fluid" role="tabpanel" aria-labelledby="basic-details-tab">
	<div class="modal-body">
		<form name="form" #f="ngForm">
			<div class="mb-3 row required">
				<label for="crop" class="col-sm-3 col-form-label fw-bold" jhiTranslate="program-settings-manager.basic-details.crop">Crop</label>
				<div class="col-sm-4">
					<input type="text" class="form-control" name="crop" id="crop" [(ngModel)]="program.crop" #cropName="ngModel" [disabled]="true"/>
				</div>
			</div>
			<div class="mb-3 row required">
				<label for="programName" class="col-sm-3 col-form-label fw-bold" jhiTranslate="program-settings-manager.basic-details.program-name">Program Name</label>
				<div class="col-sm-4">
					<input type="text" class="form-control" name="name" id="name" [(ngModel)]="program.name" #programName="ngModel" [maxLength]="50"/>
				</div>
			</div>
			<div class="mb-3 row required">
				<label class="col-sm-3 col-form-label fw-bold" jhiTranslate="program-settings-manager.basic-details.program-start-date">Program Start Date</label>
				<div class="col-sm-4">
                    <div class="input-group">
                        <input class="form-control" [placeholder]="'global.date.placeholder' | translate" [(ngModel)]="startDate"
                               ngbDatepicker #date="ngbDatepicker" id="date" name="date" required/>
                        <button class="btn btn-outline-secondary calendar" style="height: 33px;" (click)="date.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                    </div>
                </div>
			</div>
			<div class="mb-3 row required">
				<label for="dropdownLocations" class="col-sm-3 col-form-label fw-bold" jhiTranslate="program-settings-manager.basic-details.program-breeding-default-location">Program Default Breeding Location</label>
				<div class="col-sm-5">
					<jhi-locations-select [(value)]="program.breedingLocationDefaultId" [showFilterOptions]="true"></jhi-locations-select>
				</div>
			</div>
			<div class="mb-3 row required">
				<label for="dropdownLocations" class="col-sm-3 col-form-label fw-bold" jhiTranslate="program-settings-manager.basic-details.program-storage-default-location">Program Default Storage Location</label>
				<div class="col-sm-5">
					<jhi-locations-select [(value)]="program.storageLocationDefaultId" [showFilterOptions]="true" [storageLocationsOnly]="true"></jhi-locations-select>
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button (click)="reset()" class="btn btn-secondary">
			<span class="fa fa-ban me-2"></span><span jhiTranslate="entity.action.reset"></span>
		</button>
		<button (click)="delete()" class="btn btn-danger ms-2">
			<span class="fa fa-trash me-2"></span><span jhiTranslate="entity.action.delete"></span>
		</button>
		<button (click)="save()" [disabled]="!isFormValid(f)" class="btn btn-primary ms-2">
			<span *ngIf="isLoading" class="throbber throbber-btn me-2"></span>
			<span class="fa fa-save me-2"></span><span jhiTranslate="entity.action.save"></span>
		</button>
	</div>
<div>
